/**
 * @file 声かけの面 — 場面ごとの声のかけ方を読む。
 *
 * @what: `voice_guide_v1.yaml` の群と場面を並べる。場面は畳んでおき、開くと避けたい言い方・
 *   置きかえ・理由が出る。家族やまなぶ人に依存しないので、読み込みも保存もしない。
 * @why: 声のかけ方は、その場で迷ったときに開いて確かめるものなので、1画面に全部を広げず
 *   場面の名前だけを並べて畳む。
 * @failure: 手引きの形が壊れていれば module の評価時に落ちる (voiceGuide.ts) ので、
 *   この画面には欠けた状態が出ない。
 */

import { voiceGuide } from "@/features/study/model/voiceGuide";

export function VoicePanel() {
  return (
    <section className="study-section">
      <h2 className="study-section-title">
        <span aria-hidden="true">💬</span> 声かけ
      </h2>
      <p className="study-section-help">
        おうちで問題に取り組むときの、場面ごとの声のかけ方です。場面を開くと、避けたい言い方と
        その置きかえが出ます。
      </p>

      <table className="study-voice-principles">
        <caption>どの場面にも共通すること</caption>
        <tbody>
          {voiceGuide.principles.map((p) => (
            <tr key={p.label}>
              <th scope="row">{p.label}</th>
              <td>{p.body}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {voiceGuide.groups.map((group) => (
        <div key={group.id} className="study-voice-group">
          <h3 className="study-voice-group-title">{group.label}</h3>
          {group.cases.map((c) => (
            <details key={c.id} className="study-voice-case">
              <summary>
                <span className="study-voice-case-label">{c.label}</span>
                {c.overlooked ? <span className="study-voice-flag">見落としやすい</span> : null}
              </summary>
              <div className="study-voice-pair">
                <div className="study-voice-block study-voice-block--ng">
                  <p className="study-voice-block-title">避けたい</p>
                  <ul>
                    {c.ng.map((line, i) => (
                      <li key={`${c.id}-ng-${String(i)}`}>{line}</li>
                    ))}
                  </ul>
                </div>
                <div className="study-voice-block study-voice-block--ok">
                  <p className="study-voice-block-title">置きかえ</p>
                  <ul>
                    {c.ok.map((line, i) => (
                      <li key={`${c.id}-ok-${String(i)}`}>{line}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <p className="study-voice-why">{c.why}</p>
            </details>
          ))}
        </div>
      ))}
    </section>
  );
}
